import axios from "axios";

/** Timeout por archivo (fotos/vídeos/documentos pesados). */
export const CAPTACION_UPLOAD_TIMEOUT_MS = 5 * 60 * 1000;

/** Subidas simultáneas máximas. */
export const CAPTACION_UPLOAD_PARALLEL = 5;

/** Reintentos automáticos por archivo. */
export const CAPTACION_UPLOAD_MAX_RETRIES = 4;

export const CAPTACION_UPLOAD_RETRY_MS = [2000, 5000, 10000, 20000];

export function captacionApiOrigin() {
  return window.location.hostname === "localhost"
    ? "http://localhost:4000"
    : "https://vitalcasa-crm-production.up.railway.app";
}

export function captacionApiBase() {
  return `${captacionApiOrigin()}/api`;
}

function authHeaders() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/** Multipart directo al servidor (evita timeout del proxy de Vercel). */
export async function postCaptacionMultipart(path, formData) {
  const res = await axios.post(`${captacionApiBase()}${path}`, formData, {
    timeout: CAPTACION_UPLOAD_TIMEOUT_MS,
    headers: { ...authHeaders() },
  });
  return res;
}

export function resolveCaptacionMediaUrl(url) {
  if (!url) return "";
  if (String(url).startsWith("http")) return url;
  const base = captacionApiOrigin();
  return `${base}${String(url).startsWith("/") ? "" : "/"}${url}`;
}

export async function uploadCaptacionFoto(captacionId, file) {
  const fd = new FormData();
  fd.append("fotos", file);
  const res = await postCaptacionMultipart(`/captaciones/${captacionId}/fotos-reportaje`, fd);
  const fotos = res.data?.fotos || [];
  return fotos[0] || null;
}

export async function uploadCaptacionVideo(captacionId, file) {
  const fd = new FormData();
  fd.append("videos", file);
  const res = await postCaptacionMultipart(`/captaciones/${captacionId}/videos-reportaje`, fd);
  const videos = res.data?.videos || [];
  return videos[0] || null;
}

export async function uploadCaptacionDocumento(captacionId, file, meta = {}) {
  const fd = new FormData();
  fd.append("documentos", file);
  fd.append(
    "documentos_meta",
    JSON.stringify([
      {
        nombre_documento: meta.nombre_documento || file.name || "Documento",
        tipo_codigo: meta.tipo_codigo || "documento_generico",
        descripcion_tipo: meta.descripcion_tipo ? String(meta.descripcion_tipo).trim() : null,
      },
    ])
  );
  if (
    meta.forzar_validacion_encargo === true
    || meta.forzar_validacion_encargo === "true"
    || meta.forzar_validacion_encargo === "1"
  ) {
    fd.append("forzar_validacion_encargo", "true");
  }
  const res = await postCaptacionMultipart(`/captaciones/${captacionId}/documentos`, fd);
  const insertados = res.data?.data || [];
  const rev = res.data?.encargoRevision
    ? {
        ...res.data.encargoRevision,
        conservadoComoGenerico: !!res.data.encargoRevision.conservadoComoGenerico,
      }
    : null;
  const doc = insertados[0] || null;
  // Revisión rechazó y no hay fila (borrado legacy): error permanente.
  if (!doc?.id && rev && rev.ok === false) {
    const err = new Error(
      rev.mensaje || rev.motivo || "El documento no se aceptó como encargo",
    );
    err.encargoRevision = rev;
    err.noRetry = true;
    throw err;
  }
  if (!doc?.id) return null;
  if (rev) doc.encargoRevision = rev;
  return doc;
}

export async function sleep(ms) {
  return new Promise((r) => setTimeout(r, ms));
}
